import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full h-full" }
const _hoisted_2 = { class: "flex flex-col h-full justify-center items-center" }
const _hoisted_3 = { key: 0 }

import {onMounted, ref} from "vue";
import {useDisdiMaintenanceStore} from "@/stores/DisdiMaintenanceStore";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import Error from "@/components/Error";
import router from "@/router";
import {useGlobalStore} from "@/stores/GlobalStore";
import {SystemCompanySettings} from "@/models/SystemCompanySettings";
import {MiscService} from "@/utilities/services/entities/MiscService";
import OAuthService from "@/utilities/services/OAuthService";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {disdiClientConfig} from "@/AppConfig";



export default /*@__PURE__*/_defineComponent({
  __name: 'DisdiLogin',
  setup(__props) {

const globalStore = useGlobalStore();
const disdiStore = useDisdiMaintenanceStore();
const miscService = new MiscService();

const initializing = ref<boolean>(false);

const getTokenAndLogin = async ()=>{
  const authService = new OAuthService(globalStore.getAuthorityUrl(), disdiClientConfig.clientId, disdiClientConfig.scopes, disdiClientConfig.callback, disdiClientConfig.silent);
  await authService.login()
}

onMounted(async ()=>{
  initializing.value = true;

  globalStore.resetState();
  globalStore.user = null;
  globalStore.token = "";

  globalStore.oAuth.routeAfterLogin = "/disdi/maintain";
  disdiStore.currentDisdiId = router.currentRoute.value.params.id as string;

  const startupConfig = await miscService.getStartupConfig(ErrorLocationType.login);
  if (startupConfig === null) {
    initializing.value = false;
    return;
  }

  globalStore.settings.defaultHiddenColumns = startupConfig.preferenceInfo;
  globalStore.settings.systemCompanySettings = new SystemCompanySettings(startupConfig.companyName, startupConfig.companyIdCode) ;
  globalStore.settings.startupConfig = startupConfig.startupInfo;

  await getTokenAndLogin();

  initializing.value = false;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Error), {
      errorLoc: _unref(ErrorLocationType).login
    }, null, 8, ["errorLoc"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('disdi.login.description')), 1),
      (initializing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(LoadingSpinner)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})